import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { Grid, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TPartnerForm } from "@/features/talent/types/partnerForm";
import { divider } from "@/theme/colors";

type TPartnerContractInfoFormProps = {
  readonly?: boolean;
};

export const PartnerContractInfoForm: FC<TPartnerContractInfoFormProps> = ({ readonly }) => {
  const { control } = useFormContext<TPartnerForm>();

  return (
    <InnerBox title={<Typography variant="sub16Bold">契約情報</Typography>} showDivider={false} borderColor={divider.high} sx={{ gap: "24px" }}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="contractInfo">
            <Textarea readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="billingInfo">
            <Textarea readonly={readonly} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
